import { pricingService } from './pricing.service';
import { DEFAULT_TAX_RATE } from '../models/pricing.types';
export const itineraryPricingService = {
    calculateBookingItemPricing(input) {
        const breakdown = pricingService.calculate({
            unitPrice: Number(input.pricePerService),
            quantity: input.priceType === 'PERSON'
                ? Number(input.quantityOfParticipants)
                : Number(input.duration ?? 1),
            priceType: input.priceType,
            standardCapacity: input.standardCapacity,
            overflowPrice: input.overflowPrice,
            conciergeCommissionRate: Number(input.commissionAmount),
            conciergeCommissionType: input.commissionType,
            emantaCommissionRate: 0,
            taxRate: input.taxRate,
        });
        return {
            subtotal: breakdown.servicePrice,
            commission: breakdown.conciergeCommission,
            tax: breakdown.vat,
            total: breakdown.customerTotal,
        };
    },
    calculateItineraryTotals(items) {
        if (!items || items.length === 0) {
            return { subtotal: 0, commission: 0, tax: 0, total: 0, totalParticipants: 0, totalServices: 0 };
        }
        let subtotal = 0;
        let commission = 0;
        let tax = 0;
        let totalParticipants = 0;
        let totalServices = 0;
        for (const item of items) {
            const itemSubtotal = parseFloat(String(item.subtotal || 0));
            const itemCommission = parseFloat(String(item.commission_total_value || 0));
            subtotal += itemSubtotal;
            commission += itemCommission;
            const itemTaxRate = parseFloat(String(item.tax_rate || DEFAULT_TAX_RATE));
            tax += (itemSubtotal + itemCommission) * itemTaxRate;
            totalParticipants += parseInt(String(item.quantity_of_participants || 0), 10);
            totalServices += parseInt(String(item.services_amount || 1), 10);
        }
        return {
            subtotal: pricingService.round(subtotal),
            commission: pricingService.round(commission),
            tax: pricingService.round(tax),
            total: pricingService.round(subtotal + commission + tax),
            totalParticipants,
            totalServices,
        };
    },
    isUsingOverbooking(pax, standardCapacity, overflowPrice) {
        return overflowPrice != null && pax > standardCapacity;
    },
    getOverbookingMessage(pax, standardCapacity, basePrice, overflowPrice) {
        const overflowPax = pax - standardCapacity;
        return `Usando sobreventa: ${standardCapacity} espacios estándar ($${basePrice.toFixed(2)}/persona) + ${overflowPax} espacios adicionales ($${overflowPrice.toFixed(2)}/persona)`;
    },
    getTaxRateDisplay(items) {
        if (items.length === 0)
            return '';
        const taxRates = items
            .map((item) => parseFloat(String(item.tax_rate || DEFAULT_TAX_RATE)))
            .filter((rate, index, self) => self.indexOf(rate) === index);
        if (taxRates.length === 1) {
            return ` (${(taxRates[0] * 100).toFixed(0)}%)`;
        }
        return ' (variable)';
    },
    formatCurrency(value, currency = '$') {
        return pricingService.formatCurrency(value);
    },
    round(value) {
        return pricingService.round(value);
    },
};
export default itineraryPricingService;
